import { SegmentedValue } from 'antd/es/segmented';
import { AlertType, IWebhook, IWebhooksCountConfig } from './types';
import { standardAIData, standardMAData, maOpsFields } from './constant';
import { AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS } from '@src/utils/aiAlerts/mapping';

export const getWebhooksCountConfig = (webhooks: IWebhook[]): IWebhooksCountConfig => {
  const webhooksCountConfig: IWebhooksCountConfig = {
    total: {
      count: webhooks.length,
      label: 'Total',
      value: 'total',
    },
    enabled: {
      count: 0,
      label: 'Enabled',
      value: 'enabled',
    },
    disabled: {
      count: 0,
      label: 'Disabled',
      value: 'disabled',
    },
    error: {
      count: 0,
      label: 'Error',
      value: 'error',
    },
  };

  webhooks.forEach((webhook) => {
    if (webhook.error) {
      webhooksCountConfig.error.count += 1;
    } else {
      if (webhook.status) {
        webhooksCountConfig.enabled.count += 1;
      } else {
        webhooksCountConfig.disabled.count += 1;
      }
    }
  });

  return webhooksCountConfig;
};

export const getFilterWebhookList = (webhooks: IWebhook[], filter: SegmentedValue): IWebhook[] => {
  if (filter === 'total') {
    return webhooks;
  }

  if (filter === 'enabled') {
    return webhooks.filter((webhook) => webhook.status);
  }

  if (filter === 'disabled') {
    return webhooks.filter((webhook) => !webhook.status && !webhook.error);
  }

  if (filter === 'error') {
    return webhooks.filter((webhook) => webhook.error);
  }

  return [];
};

export const getAlertStandardData = (alertFields, alertType: AlertType) => {
  const returnData = {};
  const standardAlertData = alertType === 'AI' ? standardAIData : standardMAData;
  standardAlertData.forEach((data) => {
    returnData[data.key] = alertFields && alertFields[data.key] ? alertFields[data.key] : data.key;
  });
  return returnData;
};

export const getMAOpsData = (optionalFields, checkedOptionalFields) => {
  const returnData = {};
  maOpsFields.forEach((data) => {
    if (checkedOptionalFields?.[data.key]) {
      returnData[data.key] = optionalFields?.[data.key] ? optionalFields[data.key] : data.key;
    }
  });
  return returnData;
};

export const getAlertCustomData = (customFields) => {
  const returnData = {};
  customFields.forEach((data) => {
    returnData[data.customKey] = data.customValue;
  });
  return returnData;
};

export const filterEditedAlertStandardFields = (alertFields, alertType: AlertType) => {
  const returnData = {};
  const standardAlertData = alertType === 'AI' ? standardAIData : standardMAData;

  standardAlertData.forEach((data) => {
    if (alertFields[data.key] && alertFields[data.key] !== data.key) {
      returnData[data.key] = alertFields[data.key];
    }
  });
  return returnData;
};

export const filterCheckedEditedMAOptFields = (optionalFields) => {
  const returnOptionalData = {};
  const returnCheckData = {};

  maOpsFields.forEach((data) => {
    if (optionalFields[data.key] && optionalFields[data.key] !== data.key) {
      returnOptionalData[data.key] = optionalFields[data.key];
    }
    if (optionalFields[data.key]) {
      returnCheckData[data.key] = true;
    }
  });
  return { alertManualOpsFields: returnOptionalData, checkedAlertManualOptFields: returnCheckData };
};

export const getFriendlyErrorMessage = (errorMessage) => {
  if (errorMessage.message) {
    return errorMessage.message;
  }
  return 'Something went wrong. Please try again later.';
};

export const isAIAlert = (alertType: AlertType) => alertType === 'AI';

export const getModuleLabel = (module) =>
  AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS.find(({ value }) => value == module)?.label;
